import React, { Fragment, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import $ from 'jquery';
import moment from 'moment';
import { ViewLinkVerificationWrapper } from '../LinkVerificationWrapper';
import { getApiLinkVerificationsUrl } from '../../utilities/urlHelper';
import { addSuccessMessage } from '../../utilities/notificationUtilities';
import { canDeleteVerificationSchedule, canUpdateVerificationSchedule } from '../../utilities/permissionsUtilities';

const VerifyLinkModal = (props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {
        id, title, url, icon_url, closeModal, verification_schedule_id,
    } = props;

    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            return props.closeModal();
        }
    };
    const verifyContent = () => {
        const url = getApiLinkVerificationsUrl(id, verification_schedule_id);
        const type = 'POST';
        if (isSubmitting) return;
        setIsSubmitting(true);
        $.ajax({ url, type })
            .then(({ link_id }) => {
                setIsSubmitting(false);
                props.onVerification(link_id);
                addSuccessMessage('Content verified');
                return props.closeModal();
            });
    };

    const submitButtonText = isSubmitting ? 'Verifying...' : 'Verify content';
    const submitButtonClass = isSubmitting ? 'is-disabled' : '';

    return (
        <div className="react-modal open" onMouseDown={onClickModal}>
            <div className="modal-content p2">
                <h2>
                    Verify link content
                </h2>
                <p className="mb3">View link content below to verify that it's up to date.</p>
                <div className="form-group mb3">
                    <div className="flex">
                        <div className="flex">
                            <img className="flex-none mr2" height="28" width="28" alt="link icon" src={icon_url} />
                        </div>
                        <div className="flex">
                            <a href={url} target="_blank" rel="noopener noreferrer">
                                {title}
                            </a>
                        </div>
                    </div>

                </div>
                <div className="right-align mt2">
                    <span
                        className="btn-secondary  mr1"
                        aria-label="Close"
                        role="button"
                        onClick={closeModal}
                    >
                        Close
                    </span>
                    {canDeleteVerificationSchedule()
                    && (
                        <span
                            className={`btn btn-primary ${submitButtonClass}`}
                            aria-label="Delete"
                            role="button"
                            onClick={verifyContent}
                        >
                            {submitButtonText}
                        </span>
                    )}

                </div>
            </div>
        </div>
    );
};

const VerifyLinkWrapper = (props) => {
    const [showModal, setShowModal] = useState(false);
    const { link } = props;
    const { onlyVerify } = props;
    const { canVerify } = props;
    const [verificationId, setVerificationId] = useState(false);
    const params = new URLSearchParams(window.location.search);
    useEffect(() => {
        if (link.verification && link.verification_schedule) {
            const lastVerified = moment(link.verification.created_at).add(link.verification_schedule.days, 'days');
            const lastVerifiedToToday = (moment().diff(lastVerified, 'days'));
            if (lastVerifiedToToday < 0) setVerificationId(link.verification_id);
        }
        if (params.get('utm_source') === 'verify-link') {
            if (parseInt(params.get('link_id')) === link.id) {
                setShowModal(true);
            }
        }
    }, []);

    const deleteHandler = () => {
        setShowModal(false);
        addSuccessMessage('Link verification deleted');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
    };
    const onVerification = id => {
        props.afterVerification(id);
        setVerificationId(id);
    };

    return (
        verificationId
            ? !onlyVerify && (
                <ViewLinkVerificationWrapper
                    showModal={showModal}
                    setShowModal={setShowModal}
                    {...link}
                    onDelete={deleteHandler}
                />
            )
            : (
                <Fragment>
                    {(canVerify || canUpdateVerificationSchedule()) && <span className="dropdown-option blue" onClick={() => setShowModal(true)}>Verify link</span>}
                    {showModal && createPortal(<VerifyLinkModal
                        {...link}
                        onVerification={(id) => onVerification(id)}
                        closeModal={() => setShowModal(false)}
                    />, document.body)}
                </Fragment>
            )
    );
};

export default VerifyLinkWrapper;
